export { default } from './TargetingConfiguration';
export * from './TargetingConfiguration.types';
